import { render } from "./BuddiTest.vue?vue&type=template&id=4e8aff6b&scoped=true"
import script from "./BuddiTest.vue?vue&type=script&lang=js"
export * from "./BuddiTest.vue?vue&type=script&lang=js"

import "./BuddiTest.vue?vue&type=style&index=0&id=4e8aff6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8aff6b"]])

export default __exports__